import React, { useState } from "react";
import style from "./style.module.css";
import FlexComponentMobile from "../../Trade/Listing/HomepageRevamp4.0/FlexComponentMobile/FlexComponentMobile";
import HeadLines from "../../CommonComponents/HeadLines";
import { isMobile } from "../../helperFunc";
import { KycMen } from "../../icon_assets";
import Button from "../../CommonComponents/Button";
import Registration from "../../Registration/Registration";

const CompleteKyc = () => {
  const [show, setShow] = useState(false);
  const totalItems = "01";
  const hadleKyc = () => {
    setShow(true);
  };

  return (
    <>
      {show && <Registration show={show} setShow={setShow} />}

      <div
        className={isMobile ? `margin-bottom40` : `${style["margin-bottom30"]}`}
      >
        {isMobile ? (
          <FlexComponentMobile leftTitle="My Pending Items" />
        ) : (
          <div className="d-flex align-items-center justify-content-space-between">
            <div className="d-flex align-items-center gap8">
              <HeadLines
                text="My Pending Items"
                className={
                  isMobile
                    ? ``
                    : `font-weight500 font-size18 line-height21 colorDark5`
                }
              />
              <HeadLines
                text={totalItems}
                className={
                  isMobile
                    ? ``
                    : `font-weight500 font-size18 line-height21 backAccent3 textColorWhite boxRadius4 ${style.padding4_5} ${style["fixsize"]}`
                }
              />
            </div>
          </div>
        )}

        <div
          className={`${
            isMobile
              ? `${style["height178"]} ${style["mobCardShadow"]}`
              : style["deskCardWidthHeight"]
          }`}
        >
          <div
            className={`margin-top20 ${
              isMobile ? style["mobcardBorder"] : style["deskcardBorder"]
            }`}
          >
            <div
              className={`d-flex flex-d-col ${isMobile ? `gap12` : `gap10`}`}
            >
              <img
                src={KycMen}
                style={{
                  height: isMobile ? "42px" : "60px",
                  width: isMobile ? "42px" : "60px",
                }}
              />

              <HeadLines
                text="Complete Your KYC"
                className={`${
                  isMobile
                    ? `${style["mobileHeading"]}`
                    : `${style["desktopHeading"]}`
                }`}
              />

              <HeadLines
                text="Please submit the following documents and verify your profile."
                className={`${style["textHeading"]}`}
              />
            </div>
          </div>
          <div>
            <Button
              className={`${style["mobileButton"]} backAccent3 textColorWhite padding-top12 padding-bottom12 font-size14 line-height16 font-weight400 w-100`}
              onClick={hadleKyc}
              title="Complete KYC"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CompleteKyc;
